<template>
  <div class="map-block">
    <div id="dark-map" ref="mapContainer"></div>
    <div class="container position-relative">
      <div class="map-block--popup">
        <div
          class="paragraph--xxlarge wide text-uppercase text-color-quinary border-bottom-quinary padding-bottom-1-lg mb-4"
        >
          SLOVAKIA BRATISLAVA
        </div>
        <div class="row align-items-center">
          <div class="col-lg-4 col-6 mb-lg-0 mb-3">
            <div
              class="paragraph--small wide text-uppercase text-color-quinary mb-2"
            >
              Address
            </div>
            <a href="https://www.google.com/maps/dir//Devínska+Nová+Ves+7467,+841+07+Bratislava" target="_blank" class="text-decoration-none">
              <address class="paragraph--large text-color-senary">
                Squarebizz Bory<br />
                Devínska Nová Ves 7467<br />
                841 07 <br />
                Bratislava
              </address>
            </a>
          </div>
          <div class="col-lg-4 col-6 mb-lg-0 mb-3">
            <div
              class="paragraph--small wide text-uppercase text-color-quinary mb-2"
            >
              OPENING HOURS
            </div>
            <address class="paragraph--large text-color-senary">
              Monday to Sunday<br />
              By Appointment Only<br />
              +421 949 006 016
            </address>
          </div>
          <div class="col-lg-4 col-6 mb-lg-0 mb-3">
            <div
              class="paragraph--small wide text-uppercase text-color-quinary mb-2"
            >
              CONTACTS
            </div>
            <address class="paragraph--large text-color-senary">
              Phone: +421 949 006 016<br />
              E-mail: info@selected.sk<br />
              Whatsapp: +421 949 006 016
            </address>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const mapContainer = ref(null);
let map = null;

onMounted(() => {
  if (!mapContainer.value) return;

  // Squarebizz Bory, Devínska Nová Ves 7467, Bratislava
  const location = [48.18836, 17.05306];

  map = L.map(mapContainer.value, {
    center: location,
    zoom: 14,
    zoomControl: false,
    attributionControl: false,
    scrollWheelZoom: false,
    dragging: true,
  });

  // CartoDB Dark Matter - free dark tiles, no API key
  L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
    subdomains: 'abcd',
    maxZoom: 19,
  }).addTo(map);

  // Pulsing marker with label using divIcon
  const pulseIcon = L.divIcon({
    className: 'pulse-marker',
    html: `
      <div class="pulse-dot"></div>
      <div class="pulse-ring"></div>
      <div class="pulse-ring pulse-ring--delay"></div>
      <a href="https://www.google.com/maps/dir//Devínska+Nová+Ves+7467,+841+07+Bratislava" target="_blank" class="pulse-label-link">
        <span class="pulse-label notranslate" translate="no">SELECTED SHOWROOM</span>
      </a>
    `,
    iconSize: [140, 60],
    iconAnchor: [70, 20],
  });

  L.marker(location, { icon: pulseIcon }).addTo(map);
});

onBeforeUnmount(() => {
  if (map) {
    map.remove();
    map = null;
  }
});
</script>

<style>
/* Pulse marker - NOT scoped so Leaflet can render it */
.pulse-marker {
  position: relative;
}

.pulse-dot {
  width: 14px;
  height: 14px;
  background: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.6);
}

.pulse-ring {
  width: 40px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse-expand 2s ease-out infinite;
  z-index: 2;
}

.pulse-ring--delay {
  animation-delay: 0.8s;
}

@keyframes pulse-expand {
  0% {
    width: 14px;
    height: 14px;
    opacity: 1;
  }
  100% {
    width: 60px;
    height: 60px;
    opacity: 0;
  }
}

.pulse-label-link {
  text-decoration: none;
}

.pulse-label {
  position: absolute;
  top: calc(50% + 26px);
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: #ffffff;
  text-transform: uppercase;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);
  z-index: 3;
  transition: opacity 0.2s;
  cursor: pointer;
}

.pulse-label:hover {
  opacity: 0.7;
}
</style>

<style scoped>
#dark-map {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  z-index: 0;
}
</style>
